const getInsuranceRecord = (input) => {
  if (Array.isArray(input)) return input[0] || {};
  if (input?.data) return input.data;
  if (input && typeof input === 'object') return input;
  return {};
};

export const normalizeInsuranceData = (input = {}) => {
  const record = getInsuranceRecord(input);

  return {
    id: record?.id || '',
    patientId: record?.patientId || '',
    type: record?.type || record?.typeOfInsurance || '',
    groupId: record?.groupId || record?.groupID || '',
    planId: record?.planId || record?.planType || '',
    company: {
      name: record?.company?.name || record?.companyName || '',
    },
  };
};

// NOTE: Get insurance state for Redux: data + validation flag.
// disableNextButton is true if type is empty (required field).
export const getInsuranceState = (input) => {
  const data = normalizeInsuranceData(input);
  return {
    data,
    disableNextButton: !data.type,
  };
};

export const buildInsurancePatchPayload = (insuranceData, patientId) => {
  const insurance = normalizeInsuranceData(insuranceData);

  return {
    insurances: [
      {
        patientId,
        type: insurance.type || null,
        groupId: insurance.groupId || null,
        planId: insurance.planId || null,
        company: {
          name: insurance.company?.name || null,
        },
      },
    ],
  };
};
